export enum FiltrableItemTypeEnum {
  Signal = 0,
  Algorithm = 1,
  CTResult = 2,
  CTMeasurement = 3,
}
